function getLocation() {
  return fetch('https://geoip.crispstudio.cloud/', {
    method: 'get'
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(Error('error'));
  }).catch(error => {
    return Promise.reject(Error(error.message));
  });
}

var locationPopup = document.querySelector('.location-popup');

if (locationPopup) {
  var locationData = JSON.parse(localStorage.getItem('CRISP.location3'));
  var selectedLocale = localStorage.getItem('CRISP.selectedLocale');
  var locationPopupClosed = localStorage.getItem('CRISP.locationPopupClosed');
  var locationPopupDelay = Number(locationPopup.dataset.delay) * 1000;

  if (selectedLocale && Shopify.locale !== selectedLocale) {
    var newLocale = selectedLocale === 'en' ? '' : selectedLocale;
    //window.location.pathname = '/' + newLocale
  }

  if (!locationData) {
    var user = {
      isInEU: null,
      locale: null,
    };

    var store = {
      isInEU: Shopify.country === 'US' || Shopify.country === 'AU' ? false : true,
      isInAU: Shopify.country === 'AU' ? true : false,
      locale: Shopify.locale,
      publishedLocales: Shopify.publishedLocales
    };

    getLocation().then(response => {
      user.isInEU = response.result.isInEuropeanUnion;
      user.isInAU = response.result.code === 'AU' ? true : false;
      user.locale = response.result.code.toLowerCase();
      user.countryNames = response.country.names;

      locationData = {
        store: store,
        user: user
      };

      localStorage.setItem('CRISP.location3', JSON.stringify(locationData));
      handleLocation(locationData);
    });
  } else {
    handleLocation(locationData);
  }

  locationPopup.querySelector('.js-decline-redirect').addEventListener('click', function () {
    localStorage.setItem('CRISP.locationPopupClosed', 'true');
    locationPopup.ariaHidden = true;
  });

  if (locationPopup.querySelector('.js-decline-redirect2') != null) {
    locationPopup.querySelector('.js-decline-redirect2').addEventListener('click', function (e) {
      e.preventDefault();
      localStorage.setItem('CRISP.locationPopupClosed', 'true');
      locationPopup.ariaHidden = true;
    });
  }

  function handleLocation(data) {
    if (data.user.isInEU && data.store.isInEU) {
      if (!selectedLocale && data.user.locale !== data.store.locale) {
        if (data.store.publishedLocales.includes(data.user.locale)) {
          localStorage.setItem('CRISP.selectedLocale', data.user.locale);
          window.location.pathname = '/' + data.user.locale;
        } else {
          localStorage.setItem('CRISP.selectedLocale', 'en');
          if (data.store.locale !== 'en') {
            window.location.pathname = '/';
          }
        }
      }
    } else if (!((Shopify.shop == 'by-ekobo-usa.myshopify.com' && data.user.locale == 'us') || (Shopify.shop == 'by-ekobo-com.myshopify.com' && data.user.isInEU) || (Shopify.shop == 'ekobo-australia.myshopify.com' && data.user.locale == 'au'))) {
      if (!locationPopupClosed) {
        setTimeout(() => {
          const ttl = document.querySelector('.location-popup__ttl');
          const btn = locationPopup.querySelector('.js-decline-redirect');
          if (data.user.isInEU || data.user.locale == 'au' || data.user.locale == 'us') {
            if (Shopify.shop == 'ekobo-australia.myshopify.com') {
              const btnAu = locationPopup.querySelector('.location-popup__btn--au');
              if (btnAu != null) btnAu.style.display = 'none';
            }
            if (Shopify.shop == 'by-ekobo-com.myshopify.com') {
              const btnEu = locationPopup.querySelector('.location-popup__btn--eu');
              if (btnEu != null) btnEu.style.display = 'none';
            }
            if (Shopify.shop == 'by-ekobo-usa.myshopify.com') {
              const btnUs = locationPopup.querySelector('.location-popup__btn--us');
              if (btnUs != null) btnUs.style.display = 'none';
            }
          } else {
            btn.style.display = 'none';
          }

          locationPopup.ariaHidden = false;
        }, locationPopupDelay);
      }
    }
  }
}